<!--https://appdividend.com/2018/05/08/vuex-axios-get-request-tutorial-with-example/#Step_6_Display_the_coins_in_table_format -->

<template>
  <div class="container" style="margin-top: 3rem;">

  <div>
    <b-img src="/public/downloads/directories/images/Library.jpg" fluid alt="Library"></b-img>
  </div>

    <br/>
    <br/>
    <h2>Aktuelle Dokumente</h2>
    <table class="table table-striped table-hover table-bordered dt-responsive nowrap">
      <thead>
        <tr>
          <th>Dateiname</th>
          <th>Dateityp</th>
          <th>Dateigröße</th>
          <th>Beschreibung</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="doc in documents" :key="doc.fileName">
          <td><a v-bind:href="doc.fileDownloadUri">{{ doc.fileName }}</a></td>
          <td>{{ doc.fileType }}</td>
          <td>{{ doc.fileSize }}</td>
          <td>{{ doc.description }}</td>
        </tr>
      </tbody>
    </table>
      <h2 style="margin-top: 5rem;">Archivierte Dokumente</h2>
      <table class="table table-striped table-hover table-bordered dt-responsive nowrap">
        <thead>
          <tr>
            <th>Dateiname</th>
            <th>Dateityp</th>
            <th>Dateigröße</th>
            <th>Beschreibung</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="doc in archivedDocuments" :key="doc.fileName">
            <td><a v-bind:href="doc.fileDownloadUri">{{ doc.fileName }}</a></td>
            <td>{{ doc.fileType }}</td>
            <td>{{ doc.fileSize }}</td>
            <td>{{ doc.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>

</template>

<script>

    import {DOCU_REQUEST} from '@/store/actions/docu'
    import {ARCHIVED_DOCU_REQUEST} from '@/store/actions/archivedDocu'
    import store from '@/store'
    import { mapState } from 'vuex'

    export default {
      name: 'downloads',
      mounted () {
        this.$store.dispatch(DOCU_REQUEST);
        this.$store.dispatch(ARCHIVED_DOCU_REQUEST);
      },
      methods: {
            downloadFile: function(fileName) {
                console.log("Try to download" + fileName)
            }
      },
      computed: {
        documents: function() {
          return this.$store.getters.getDocuments
        },
        archivedDocuments: function() {
          return this.$store.getters.getArchivedDocuments
        },
      },
    }

</script>